import { TabOption } from '@praetorian-chariot/ui';
import { useMemo } from 'react';

import { ASSET_DRAWER_TAB_OPTIONS } from '@/sections/asset/constants';
import { Asset } from '@/types';

/**
 * Hook for managing Asset Drawer tab configuration
 *
 * @param asset - Optional asset for dynamic tab generation based on asset type
 * @returns Array of tab options for the drawer
 *
 * @example
 * ```typescript
 * const tabs = useAssetTabs(asset);
 * // Returns: [{ label: 'Overview', value: '' }, ...]
 * ```
 */
export function useAssetTabs(asset?: Asset): TabOption[] {
  return useMemo(() => {
    // Use base tab configuration from constants
    const baseTabs = [...ASSET_DRAWER_TAB_OPTIONS];

    // Future enhancement: Add dynamic tabs based on asset type
    // Example:
    // if (isADObject(asset)) {
    //   baseTabs.push({ label: 'AD Details', value: 'ad-details' });
    // }
    // if (isCloudResource(asset)) {
    //   baseTabs.push({ label: 'Cloud Config', value: 'cloud-config' });
    // }

    return baseTabs;
  }, [asset?.class, asset?.key]);
}
